<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		ControlsContainer,
		Text,
		type DeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	//Component
	import TemplateDirectionButton from './TemplateDirectionButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device;
	export let statuses: VCInterfaceStatus[];
	export let useV2Components = false;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = { size: 'l' };
</script>

<ControlsContainer class="mb-xs" color={useV2Components ? 'color-0' : 'color-2'}>
	<svelte:fragment slot="first">
		<TemplateDirectionButton
			size="l"
			direction="open"
			{device}
			{statuses}
			{useV2Components}
			{deviceButtonV2Props}
		/>
		<Text styleType="controls-large" class="mt-s-plus text-bold">
			{$format('text_device_control_direction_open', {
				default: 'Open',
			})}
		</Text>
	</svelte:fragment>
	<svelte:fragment slot="second">
		<TemplateDirectionButton
			size="l"
			direction="close"
			{device}
			{statuses}
			{useV2Components}
			{deviceButtonV2Props}
		/>
		<Text styleType="controls-large" class="mt-s-plus text-bold">
			{$format('text_device_control_direction_close', {
				default: 'Close',
			})}
		</Text>
	</svelte:fragment>
</ControlsContainer>
